import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { AuthModule } from '@saikin/auth/auth.module';
import { CnstModule } from '@saikin/cnst/cnst.module';
import { MatModule } from '@saikin/mat.module';

import { CouponEntryView } from './coupon.entry';
import { CouponRouting } from './coupon.routing';
import { CouponService } from './coupon.service';

import { CouponsOverviewComponent
       } from './coupons-overview/coupons-overview.component';

@NgModule({
    declarations: [
        CouponEntryView,
        CouponsOverviewComponent,
    ],
    exports: [
        CouponEntryView,
    ],
    imports: [
        AuthModule,
        BrowserModule,
        CnstModule,
        FormsModule,
        MatModule,
        ReactiveFormsModule,
        RouterModule,
        CouponRouting,
    ],
    providers: [
        CouponService,
    ]
})
export class CouponModule { }
